import { render } from "./NodesCanvasPage.vue?vue&type=template&id=f9be4702&scoped=true&ts=true"
import script from "./NodesCanvasPage.vue?vue&type=script&lang=ts"
export * from "./NodesCanvasPage.vue?vue&type=script&lang=ts"

import "./NodesCanvasPage.vue?vue&type=style&index=0&id=f9be4702&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9be4702"]])

export default __exports__